import { Injectable } from '@angular/core';
import { Configuration } from '../shared.module';
import { environment } from '@env/environment';


@Injectable()
export class AppConfig {
    static config: Configuration;
    private defaultDirectory = '/assets/Settings/';

    constructor() {}

    public load() {
        const apiName = environment.apiName;

        // (apiName)
        return new Promise((resolve, reject) => {
            const configPath = this.defaultDirectory + apiName;
            this.loadTextFileAjaxSync(configPath, 'application/json').then(json => {
                AppConfig.config = JSON.parse(json);
                resolve(AppConfig.config);
            });
        });
    }

    loadTextFileAjaxSync(filePath, mimeType) {
        return new Promise<string>((resolve, reject) => {
            const xmlhttp = new XMLHttpRequest();
            xmlhttp.open('GET', filePath, false);
            if (mimeType != null) {
                if (xmlhttp.overrideMimeType) {
                    xmlhttp.overrideMimeType(mimeType);
                }
            }
            xmlhttp.send();
            if (xmlhttp.status === 200) {
                resolve(xmlhttp.responseText);
            } else {
                reject();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/app.config.ts